var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 80,
    viewBox: "0 0 113 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.425 79.375C11.383 79.375 0 68.0371 0 54.0625C0 43.0234 7.09252 33.6367 16.9853 30.1738C16.9624 29.6992 16.95 29.2246 16.95 28.75C16.95 13.2109 29.5919 0.625 45.2 0.625C55.6702 0.625 64.7984 6.29394 69.6892 14.7227C72.373 12.7715 75.6217 11.875 79.1 11.875C88.4578 11.875 96.05 19.2754 96.05 28.75C96.05 30.8945 95.6439 32.9336 94.92 34.832C105.231 36.9062 113 45.9941 113 56.875C113 69.3027 102.883 79.375 90.4 79.375H25.425ZM39.3734 41.2305C37.7314 42.8828 37.7314 45.5547 39.3734 47.0488C41.0331 48.8418 43.7169 48.8418 45.2177 47.0488L52.2625 40.334V63.9062C52.2625 66.2441 54.1517 68.125 56.5 68.125C58.8483 68.125 60.7375 66.2441 60.7375 63.9062V40.334L67.6234 47.0488C69.2831 48.8418 71.9669 48.8418 73.4677 47.0488C75.2686 45.5547 75.2686 42.8828 73.4677 41.2305L59.3427 27.168C57.8419 25.5332 55.1581 25.5332 53.4984 27.168L39.3734 41.2305Z",
    fill: "#5CB0B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrow);
export default __webpack_public_path__ + "static/media/Vector-arrow.a94f2d7f5d0d0270b6167eda64074373.svg";
export { ForwardRef as ReactComponent };